import React from 'react';

interface DividerProps {
  orientation?: 'horizontal' | 'vertical';
  className?: string;
}

const Seperator = ({
  orientation = 'horizontal',
  className = '',
}: DividerProps) => {
  const baseStyle = {
    backgroundColor: '#e4e4e7',
    flexShrink: 0,
  };

  const horizontalStyle = {
    ...baseStyle,
    height: '1px',
    width: '100%',
    margin: '16px 0',
  };

  const verticalStyle = {
    ...baseStyle,
    width: '1px',
    height: '100%',
    margin: '0 8px',
  };

  const style = orientation === 'horizontal' ? horizontalStyle : verticalStyle;

  return <div style={style} className={className} />;
};

export default Seperator;
